var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect, createContext, useContext, useRef, } from 'react';
import { LayoutSplashScreen } from '../../../../_metronic/layout/core';
import * as authHelper from './AuthHelpers';
import { useLocation } from 'react-router-dom';
var initAuthContextPropsState = {
    auth: authHelper.getAuth(),
    saveAuth: function () { },
    getAllAuth: function () { return []; },
    currentUser: undefined,
    switchUser: function () { },
    getCurrentUserIndex: function () { return 0; },
    setCurrentUser: function () { },
    logout: function () { },
    logoutAll: function () { },
};
var AuthContext = createContext(initAuthContextPropsState);
var useAuth = function () {
    return useContext(AuthContext);
};
var AuthProvider = function (_a) {
    var children = _a.children;
    var _b = useState(authHelper.getAuth()), auth = _b[0], setAuth = _b[1];
    var _c = useState(), currentUser = _c[0], setCurrentUser = _c[1];
    var saveAuth = function (auth) {
        setAuth(auth);
        authHelper.setAuth(auth);
    };
    return (_jsx(AuthContext.Provider, __assign({ value: {
            auth: auth,
            saveAuth: saveAuth,
            getAllAuth: authHelper.getAllAuth,
            currentUser: currentUser,
            switchUser: authHelper.switchAuth,
            setCurrentUser: setCurrentUser,
            getCurrentUserIndex: authHelper.getCurrentUserIndex,
            logout: authHelper.logout,
            logoutAll: authHelper.logoutAll,
        } }, { children: children })));
};
var AuthInit = function (_a) {
    var children = _a.children;
    var _b = useAuth(), auth = _b.auth, getAllAuth = _b.getAllAuth, setCurrentUser = _b.setCurrentUser;
    var didRequest = useRef(false);
    var _c = useState(true), showSplashScreen = _c[0], setShowSplashScreen = _c[1];
    // We should request user by authToken (IN OUR EXAMPLE IT'S API_TOKEN) before rendering the application
    var pathname = useLocation().pathname;
    var isAccountSwitch = pathname.includes('/account/switch');
    useEffect(function () {
        var requestUser = function (apiToken) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    if (!didRequest.current) {
                        // const {data} = await getUserByToken(apiToken)
                        // if (data) {
                        //   setCurrentUser(data)
                        // }
                        setCurrentUser(auth === null || auth === void 0 ? void 0 : auth.data);
                    }
                }
                catch (error) {
                    console.error(error);
                    // if (!didRequest.current) {
                    //   logout()
                    // }
                }
                finally {
                    setShowSplashScreen(false);
                }
                return [2 /*return*/, function () { return (didRequest.current = true); }];
            });
        }); };
        if (!auth && getAllAuth().length) {
            !isAccountSwitch && window.location.replace('/account/switch');
        }
        if (auth) {
            requestUser(auth.data.token);
        }
        setShowSplashScreen(false);
        // eslint-disable-next-line
    }, []);
    return showSplashScreen ? _jsx(LayoutSplashScreen, {}) : _jsx(_Fragment, { children: children });
};
export { AuthProvider, AuthInit, useAuth };
